import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { TaskManagementService } from '../task-management/service/task-management.service';
import { ClassificationService } from '../../classification/classification/service/classification.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { SlaManagementService } from './service/sla-management.service';
import { requestClassificationInterface } from 'src/app/util/interfaces/requestClassification';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';

@Component({
	selector: 'register-form-sla-management',
	templateUrl: './sla-management.component.html',
	styleUrls: ['./sla-management.component.scss'],
})
export class SlaManagementComponent implements OnInit {
	labels: any = {
		lbl_geral_cancelar: 'Cancel',
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_preencha_campo_obrigatorio: 'Please fill all the mandatory fields',
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_an_errour_occour: 'An error occurred. Please try again',
		lbl_geral_selecione: 'SELECT',
		lbl_geral_deletado_com_sucesso: 'Successfully deleted',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_geral_severidade: 'Severity',
		lbl_geral_excluir: 'Delete',
		lbl_geral_nome: 'Name',
		lbl_geral_gerenciamento_sla: 'Sla Management',
		lbl_horario_comercial: 'Business Hours',
		lbl_campos_horas_preenchimento_formato:
			'The hour fields must be filled with "000" (indicating the hours) before the ":", and "00" (indicating the minutes) after the ":")',
	};

	optionsEndusers: any[] = [
		{
			name: 'endusers',
			label: 'lbl_chamado_enduser',
			inputType: 'multi-select',
			values: [], // Aqui serão inseridos os endusers
			outItems: [],
			items: [], // Lista de valores para o multi-select
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	selectedEndusers: string[] = [];

	isLoadingEndusers = true;

	constructor(
		private labelsService: LabelsService,
		private notificationService: NotificationService,
		private taskManagementService: TaskManagementService,
		private classificationService: ClassificationService,
		private slaManagementService: SlaManagementService
	) {}

	selectedTab = 'management';

	isLabelsLoading = true;
	isSlaLoading = false;
	isTemplateLoading = false;
	isEndusersLoading = false;
	showRequestClassification = true;

	serviceTypeOptions: any[] = [];
	serviceTypeFilterOptions: any[] = [];
	solutionAreaFilterOptions: any[] = [];
	solutionAreaOptions: any[] = [];
	severitiesOptions: any[] = [];
	categoriesOptions: any[] = [];
	topicsOptions: any[] = [];
	templatesOptions: any[] = [];
	slaData: any[] = []; //Tipar
	slaDataSearch: any[] = []; //Tipar

	requestClassification: requestClassificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
		severity: [],
		impact: [],
		urgency: [],
	};

	searchHeader: mspTableHeaderI[] = [
		{ name: 'id', value: 'lbl_geral_id', colType: 'text' },
		{ name: 'sla', value: 'lbl_geral_quantidade_horas_sla', colType: 'text' },
		{ name: 'solutionArea', value: 'lbl_geral_grupo', colType: 'text' },
		{ name: 'businessHours', value: 'lbl_geral_tipo_hora', colType: 'text' },
		{ name: 'secondSla', value: 'lbl_geral_quantidade_horas_segundo_prazo_sla', colType: 'text' },
		{ name: 'secondSlaBusinessHours', value: 'lbl_geral_tipo_hora_segundo_prazo', colType: 'text' },
		{ name: 'slavip', value: 'lbl_geral_quantidade_horas_sla_vip', colType: 'text' },
		{ name: 'secondSlaVip', value: 'lbl_geral_quantidade_horas_segundo_prazo_sla_vip', colType: 'text' },
		{ name: 'slaResponseTime', value: 'lbl_geral_quantidade_horas_tempo_resposta', colType: 'text' },
	];

	filter: any = {
		solutionArea: '',
		serviceType: '',
	};

	ngOnInit() {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLabelsLoading = false;
		});

		this.classificationService.getClassificationServiceType().subscribe((data) => {
			this.serviceTypeOptions = [
				{ id: '', value: '', label: this.labels.lbl_geral_selecione },
				...data
					.filter((serviceType) => serviceType.name == 'Incident' || serviceType.name == 'Service Request')
					.map((serviceType) => ({
						id: serviceType.id,
						value: serviceType.id,
						label: serviceType.label,
					})),
			];

			this.serviceTypeFilterOptions = [
				{ id: '', value: '', label: this.labels.lbl_geral_selecione },
				...data
					.filter((serviceType) => serviceType.name == 'Incident' || serviceType.name == 'Service Request')
					.map((serviceType) => ({
						id: serviceType.id,
						value: serviceType.name,
						label: serviceType.label,
					})),
			];
		});

		this.taskManagementService.getSolutionAreaByCustomer().subscribe((solutionAreas) => {
			this.solutionAreaOptions = solutionAreas;
			this.solutionAreaFilterOptions = solutionAreas;
		});

		this.taskManagementService.getSeverities().subscribe((severities) => {
			this.severitiesOptions = severities;
		});
	}

	getAllSla(): void {
		this.isSlaLoading = false;
		if (this.filter.serviceType == '') {
			this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
			return;
		}

		this.slaManagementService
			.getSla({ solutionArea: this.filter.solutionArea, serviceType: this.filter.serviceType })
			.subscribe((data) => {
				this.slaDataSearch = data;
				this.isSlaLoading = true;
			});
	}

	loadTemplate(item: string): void {
		const serviceType: string = this.loadServiceType(item);

		if (serviceType) {
			this.isTemplateLoading = true;
			this.taskManagementService.getTasksTemplates({ type: serviceType }).subscribe((templates) => {
				this.templatesOptions = templates;
				this.isTemplateLoading = false;
			});
		}
	}

	loadServiceType(item: string): string {
		let serviceType: string;

		if (item == '6') {
			serviceType = 'Service Request';
		} else if (item == '2') {
			serviceType = 'Incident';
		} else {
			serviceType = 'Unknown'; // Default value if the item doesn't match known types
		}

		return serviceType;
	}

	onServiceTypeChange(item: any): void {
		this.slaData[0].serviceTypeId = item;
		this.showRequestClassification = item == '6' || item == '2';
	}

	convertToHours(time: any): string {
		// Verifica se o valor já está no formato "hh:mm"
		if (typeof time === 'string' && time.includes(':')) {
			const [hours, minutes] = time.split(':');

			// Garante que as horas tenham 3 dígitos
			const formattedHours = hours.padStart(3, '0');

			return `${formattedHours}:${minutes.padStart(2, '0')}`;
		}

		// Caso contrário, assume que a entrada está em minutos e converte para "hh:mm"
		const hours = Math.floor(time / 60);
		const remainingMinutes = time % 60;

		return `${hours.toString().padStart(3, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
	}

	checkRequiredFields(temporary: any): boolean {
		let fieldsFilled = true; // Inicialize como true e altere para false se qualquer campo obrigatório estiver faltando.

		// Verificação dos campos comuns
		if (temporary.serviceTypeId == '') {
			fieldsFilled = false;
		}

		// Verificação dos campos específicos para "Incident"
		if (temporary.serviceTypeId == '2' && (temporary.severity == '' || temporary.solutionAreaId == '')) {
			fieldsFilled = false;
		}

		// Verificação dos campos específicos para "Service Request"
		if (temporary.serviceTypeId == '6' && temporary.category == '') {
			fieldsFilled = false;
		}

		return fieldsFilled;
	}

	clearInputs(isNew: boolean): void {
		if (isNew) {
			this.slaData = [
				{
					businessHours: '',
					category: '', //Service Request
					description: '', //Incident
					genericEnduser: '', //Incident
					highSeverity: '', //Incident
					id: '',
					notify: '', //Service Request
					restricted: '', //Service Request
					scope: '', //Service Request
					secondSla: '',
					secondSlaBusinessHours: '',
					secondSlaVip: '',
					serviceType: '',
					serviceTypeId: '',
					severity: '', //Incident
					sla: '',
					slaResponseTime: '',
					slavip: '',
					solutionArea: '',
					solutionAreaId: '',
					tasksTemplate: '',
					topic: '',
				},
			];
		}
	}

	setClassification(classification: string): void {
		this.requestClassification = JSON.parse(classification);

		this.slaData = [
			{
				businessHours: '',
				category: this.requestClassification.category[0] ? this.requestClassification.category[0].id : '', //Service Request
				description: '', //Incident
				genericEnduser: '', //Incident
				highSeverity: '', //Incident
				id: '',
				notify: '', //Service Request
				restricted: '', //Service Request
				scope: this.requestClassification.scope[0] ? this.requestClassification.scope[0].id : '', //Service Request
				secondSla: '',
				secondSlaBusinessHours: '',
				secondSlaVip: '',
				serviceType: this.requestClassification.serviceType[0] ? this.requestClassification.serviceType[0].name : '',
				serviceTypeId: this.requestClassification.serviceType[0] ? this.requestClassification.serviceType[0].id : '',
				severity: '', //Incident
				sla: '',
				slaResponseTime: '',
				slavip: '',
				solutionArea: '',
				solutionAreaId: this.requestClassification.solutionArea[0] ? this.requestClassification.solutionArea[0].id : '',
				tasksTemplate: '',
				topic: this.requestClassification.topic[0] ? this.requestClassification.topic[0].id : '',
			},
		];
	}

	openUpdatedForm(item: any): void {
		this.slaData = [item];
		this.selectedTab = 'create';

		this.loadTemplate(this.slaData[0].serviceTypeId);
		this.generateConfigurationForm();

		this.slaData[0].sla ? (this.slaData[0].sla = this.convertToHours(this.slaData[0].sla)) : '';
		this.slaData[0].slavip ? (this.slaData[0].slavip = this.convertToHours(this.slaData[0].slavip)) : '';
		this.slaData[0].secondSla ? (this.slaData[0].secondSla = this.convertToHours(this.slaData[0].secondSla)) : '';
		this.slaData[0].slaResponseTime ? (this.slaData[0].slaResponseTime = this.convertToHours(this.slaData[0].slaResponseTime)) : '';
		this.slaData[0].secondSlaVip ? (this.slaData[0].secondSlaVip = this.convertToHours(this.slaData[0].secondSlaVip)) : '';
		this.slaData.length > 0
			? (this.showRequestClassification = item.serviceTypeId == '6' || item.serviceTypeId == '2')
			: (this.showRequestClassification = false);

		if (this.slaData[0].restricted == 1) {
			this.getAllEndusers();
		}
	}

	saveSla(): void {
		if (!this.checkRequiredFields(this.slaData[0])) {
			this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
			return;
		}

		this.slaData[0].sla ? (this.slaData[0].sla = this.slaData[0].sla.replaceAll(':', '')) : '';
		this.slaData[0].slavip ? (this.slaData[0].slavip = this.slaData[0].slavip.replaceAll(':', '')) : '';
		this.slaData[0].secondSla ? (this.slaData[0].secondSla = this.slaData[0].secondSla.replaceAll(':', '')) : '';
		this.slaData[0].slaResponseTime ? (this.slaData[0].slaResponseTime = this.slaData[0].slaResponseTime.replaceAll(':', '')) : '';
		this.slaData[0].secondSlaVip ? (this.slaData[0].secondSlaVip = this.slaData[0].secondSlaVip.replaceAll(':', '')) : '';

		// Incluir end-users selecionados
		this.slaData[0].endusers = this.optionsEndusers[0].rawValues;

		if (this.slaData[0].id) {
			this.slaManagementService.updateSla(this.slaData[0]).subscribe((data) => {
				data == 409
					? this.notificationService.setNotificationMessage(this.labels.lbl_geral_classificacao_sla_existente)
					: this.notificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			});
		} else {
			this.slaData[0].serviceType = this.loadServiceType(this.slaData[0].serviceTypeId);
			this.slaManagementService.postSla(this.slaData[0]).subscribe((data) => {
				data == 409
					? this.notificationService.setNotificationMessage(this.labels.lbl_geral_classificacao_sla_existente)
					: this.notificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
			});
		}
	}

	removeSla(): void {
		if (this.slaData[0].id) {
			this.slaManagementService.deleteSla({ id: this.slaData[0].id, serviceType: this.slaData[0].serviceType }).subscribe(() => {
				this.notificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
				this.clearInputs(false);
			});
		}
	}

	getAllEndusers(): void {
		this.isEndusersLoading = true;
		setTimeout(() => {
			this.slaManagementService.getEndusers().subscribe((data) => {
				const mappedItems = data.map((item) => ({
					name: item.name,
					label: item.name,
					value: item.id,
					values: [item.id],
				}));

				this.optionsEndusers[0].items = mappedItems;
				this.isEndusersLoading = false;
				this.generateConfigurationForm();
			});
		}, 1000);
	}

	generateConfigurationForm(): void {
		let arrayFilterOptionsEnduser = [];

		if (Array.isArray(this.optionsEndusers[0].items)) {
			arrayFilterOptionsEnduser = this.optionsEndusers[0].items;
		}

		this.optionsEndusers[0].items = [];
		this.optionsEndusers[0].rawValues = [];

		for (const availableItems of arrayFilterOptionsEnduser) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.label,
				value: availableItems.value,
				values: [availableItems.value],
			};

			this.optionsEndusers[0].items.push(newItem);

			if (this.slaData[0] && Array.isArray(this.slaData[0].endusers)) {
				for (const item of this.slaData[0].endusers) {
					if (item === availableItems.value) {
						this.optionsEndusers[0].values.push(newItem);
						this.optionsEndusers[0].rawValues.push(newItem.value);
					}
				}
			}
		}
	}

	onRestrictedChange(restrictedValue: any): void {
		this.slaData[0].restricted = restrictedValue;

		if (this.slaData[0].restricted == 1) {
			this.getAllEndusers();
		}
	}
}
